<div
  *transloco="let trans; read: 'cookieConsent'"
  class="fixed inset-0 flex justify-end items-end z-50 p-6 pointer-events-none"
>
  <div
    class="relative flex flex-col items-end rounded-md shadow-xl bg-white p-4 p-4 border-t-8 border-blue pointer-events-auto w-"
  >
    <button class="absolute right-3 top-5 px-2" (click)="cancel()" data-qa="modal-close">
      <elio-svg-icon class="text-danger text-2xl" key="cross"></elio-svg-icon>
    </button>
    <section class="flex items-center space-x-4">
      <img class="h-28" [src]="'/assets/images/mascotte_hello.svg'" alt="cookie-consent-mascotte" />
      <div class="flex flex-col">
        <span class="text-black uppercase font-bold mb-2">{{ trans('title') }}</span>
        <span>{{ trans('info') }}</span>
        <!--
          Actuellement il n'y a pas de page de politique de confidentialité sur emanager.
          C'est donc le lien qui sera présent ici
          <span>
            {{ trans('info2') }}
            <a class="underline cursor-pointer" [href]="'todo'" target="_blank" rel="noopener">
              {{ trans('link') }}
            </a>
          </span>
        -->
      </div>
    </section>

    <div *ngIf="isDetailOpen" class="flex border border-gray p-2 justify-between mt-2">
      <span class="mr-2">{{ trans('analytics') }}</span>
      <label class="flex items-center cursor-pointer text-white" for="toogle">
        <div class="relative">
          <input id="toogle" class="hidden" [(ngModel)]="isGoogleAnalytics" type="checkbox" />
          <div class="w-10 h-4 bg-gray-light rounded-full shadow-inner"></div>
          <div class="toggle-dot absolute w-6 h-6 bg-gray rounded-full shadow inset-y-0 left-0"></div>
        </div>
      </label>
    </div>

    <div *ngIf="!isDetailOpen; else detailButtons" class="flex space-x-4 my-2">
      <elio-button [label]="trans('button.refuse')" (onclick)="denyAll()" dataQA="cookie-refuse-all" theme="neutral" />
      <elio-button
        [label]="trans('button.setUp')"
        (onclick)="isDetailOpen = !isDetailOpen"
        theme="neutral"
        dataQA="cookie-open-detail"
      />
      <elio-button
        class="custom-button"
        [label]="trans('button.accept')"
        (onclick)="acceptAll()"
        dataQA="cookie-accept-all"
      />
    </div>
    <ng-template #detailButtons>
      <div class="flex space-x-4 my-2">
        <elio-button
          [label]="trans('button.cancel')"
          (onclick)="cancel()"
          theme="neutral"
          dataQA="cookie-details-cancel"
        />
        <elio-button
          class="custom-button"
          [label]="trans('button.ok')"
          (onclick)="validate()"
          dataQA="cookie-details-validate"
        />
      </div>
    </ng-template>
  </div>
</div>
